module.exports = __webpack_public_path__ + "static/soundcloud-logo-f74ac70fc3ae9955a4a06382b7c1fa94.png";